const localeResources = {
    en: {
        welcome: 'Welcome',
        hello: 'Hello {name}',
    },
    ar: {
        welcome: 'أهلا و سهلا',
        hello: 'مرحبا',
        Vouchers: 'السندات',
        'Sales Account': 'حساب المبيعات',
        'Purchase Account': 'حساب المشتريات',
        'Cash Account': 'حساب النقدية',
        'Bank Account': 'حساب البنك',
        'VAT Account': 'حساب الضريبة',
        'Credit Account': 'حساب الآجل',
        'General Settings': 'الضبط العام',
        'Categories': 'الفئات',
        'Services': 'الخدمات',
        'Service Types': 'أنواع الخدمات',
        'Roles': 'الأدوار',
        'Users': 'المستخدمين',
        'Workflows': 'سير العمل',
        'Voucher Types': 'أنواع السندات',
        'Projects': 'المشاريع',
        'Calculator': 'الحاسبة',
        'Contracts': 'العقود',
        'List': 'عرض',
        'Create': 'جديد',
        'Invoices': 'الفواتير',
        'Inventory': 'المخزون',
        'Transfer': 'نقل المخزون',
        'Adjustment': 'تسوية المخزون',
        'Reports': 'التقارير',
        'Stock': 'المخزون',
        'Stock Qty': 'المخزون بالكمية',
        'Finance': 'المالية',
        'Journals': 'القيود',
        'Accounts': 'الحسابات',
        'Balance Sheet': 'ميزان المراجعة',
        'Trial Balance': 'ميزان المراجعة',
        'Profit Loss': 'قائمة الدخل',
        'Ledger': 'دفتر الحسابات',
        'CRM': 'خدمة العملاء',
        'Parties': 'الجهات',
        'Surveys': 'الإستبيانات',
        'HR': 'الموارد البشرية',
        'Employees': 'الموظفين',
        'Leaves': 'الإجازات',
        'Tasks': 'المهام',
        'Designations': 'المسميات الوظيفية',
        'Departments': 'الأقسام',
        'HR Settings': 'الإعدادات',
        'Degrees': 'الدرجات الوظيفية',
        'Leaves Types': 'أنواع الإجازات',
        'Me': 'خدماتي',
        'Inbox': 'البريد الوارد',
        'Business Trips': 'مهام العمل',
        'My Daily Tasks': 'مهامي اليومية',
        'Annual': 'إجازة سنوية',
        'Sick': 'إجازة مرضية',
        'Paternity': 'إجازة أبوة',
        'Maternity': 'إجازة أمومة',
        'Unpaid': 'إجازة بدون راتب',
        'Bereavement': 'إجازة وفاة ',
        'Emergency': 'إجازة إضطرارية ',
        'Study': 'إجازة دراسة ',
        'Other': 'إجازة أخرى ',
        'Contact us': 'تواصل معنا',
        'Name': 'الإسم',
        'Email': 'البريد الإلكتروني',
        'Message': 'الرسالة',
        'Send': 'إرسال',
        'Settings': 'الإعدادات',
        'Save': 'حفظ',
        'Cancel': 'إلغاء',
        'Edit': 'تعديل',
        'Delete': 'حذف',
        'Add': 'إضافة',
        'Close': 'إغلاق',
        'View': 'عرض',
        'Search': 'بحث',
        'Blog': 'المدونة',
        'Login': 'دخول',
        'Register': 'التسجيل',
        'Logout': 'خروج',
        'Forgot Your Password?': 'نسيت كلمة المرور؟',
        'Statistics': 'الإحصائيات',
        'Our Services': 'خدماتنا',
        'Communications': 'الإتصالات الإدارية',
        'New Design Request': 'حصر متطلبات التصميم',
        'Menu Item Color': 'لون القائمة',
        'The Product': 'المنتج',
        'The Service': 'الخدمة',
        'Vouchers Register': 'سجل السندات',
        'Land Info': 'معلومات الأرض',
        'Design Info': 'معلومات التصميم',
        'internal': 'داخلي',
        'external': 'خارجي',
        'secret': 'سري',
        'Notifications': 'الإشعارات',
        'pcs': 'قطعة',
        'meters': 'متر',
        'kg': 'كيلو',
        'grams': 'جرام',
        'liters': 'لتر',
        'cm': 'سم',
        'mm': 'مم',
        'm': 'م',
        'km': 'كم',
        'ton': 'طن',
        'gallon': 'جالون',
        'pound': 'رطل',
        'ounce': 'أوقية',
        'inch': 'بوصة',
        'foot': 'قدم',
        'yard': 'ياردة',
        'mile': 'ميل',
        'acre': 'فدان',
        'kilogram': 'كيلوجرام',
        'Design Request': 'طلب تصميم',
        'New Voucher': 'سند جديد',
        'Voucher': 'سند',
        'Total Debit': 'إجمالي المدين',
        'Total Credit': 'إجمالي الدائن',
        'Variance': 'الفرق',
        'Voucher Date': 'تاريخ السند',
        'Permissions': 'الصلاحيات',
        'Special Permissions': 'الصلاحيات الخاصة',
        'Total Users': 'إجمالي المستخدمين',
        'Total Sales Invoices': 'إجمالي فواتير المبيعات',
        'Total Purchase Invoices': 'إجمالي فواتير المشتريات',
        'Total Products': 'إجمالي المنتجات',
        'Total Services': 'إجمالي الخدمات',
        'Total Vouchers': 'إجمالي السندات',
        'Total Voucher Types': 'إجمالي أنواع السندات',
        'Total Parties': 'إجمالي الجهات',
        'General Permissions': 'الصلاحيات العامة',
        'meter_square': 'م²',
        'Cash': 'نقدي',
        'Bank': 'بنك',
        'Credit': 'دائن',
        'Debit': 'مدين',
        'Date': 'التاريخ',
        'Files': 'الملفات',
        'Active': 'نشط',
        'Projects Management': 'إدارة المشاريع',
        'New Project': 'مشروع جديد',
        'Edit Project': 'تعديل المشروع',
        'Project': 'المشروع',
        'Project Name': 'إسم المشروع',
        'Project Description': 'وصف المشروع',
        'Project Manager': 'مدير المشروع',
        'Project Start Date': 'تاريخ بداية المشروع',
        'Project End Date': 'تاريخ نهاية المشروع',
        'Project Status': 'حالة المشروع',
        'Project Type': 'نوع المشروع',
        'Project Budget': 'ميزانية المشروع',
        'Project Progress': 'تقدم المشروع',
        'Project Tasks': 'مهام المشروع',
        'Project Files': 'ملفات المشروع',
        'Project Reports': 'تقارير المشروع',
        'Project Invoices': 'فواتير المشروع',
        'Project Vouchers': 'سندات المشروع',
        'Project Expenses': 'مصاريف المشروع',
        'Project Income': 'إيرادات المشروع',
        'Project Profit': 'ربح المشروع',
        'Project Engineer': 'مهندس المشروع',
        'New Task': 'مهمة جديدة',
        'Edit Task': 'تعديل المهمة',
        'New': 'جديد',
        'Title': 'العنوان',
        'Description': 'الوصف',
        'Start Date': 'تاريخ البداية',
        'Code': 'الكود',
        'Project Code': 'كود المشروع',
        'Project Title': 'عنوان المشروع',
        'Due Date': 'تاريخ الإستحقاق',
        'Attachments': 'المرفقات',
        'Upload Files': 'رفع الملفات',
        'Client': 'العميل',
        'Status': 'الحالة',
        'End Date': 'تاريخ النهاية',
        'Save project to add tasks': 'الرجاء حفظ المشروع لإضافة المهام',
        'Tags': 'الكلمات الدلالية',
        'Color': 'اللون',
        'Task Title': 'عنوان المهمة',
        'Add Task': 'إضافة مهمة',
        'Low': 'منخفض',
        'Medium': 'متوسط',
        'High': 'عالي',
        'Priority': 'الأولوية',
        'Task Description': 'وصف المهمة',
        'Normal': 'عادي',
        'POS': 'نقطة البيع',
        'Home': 'الرئيسية',
        'Batch No': 'رقم الدفعة',
        'Product Name': 'إسم المنتج',
        'Barcode': 'الباركود',
        'Expiry Date': 'تاريخ الإنتهاء',
        'Qty': 'الكمية',
        'Quantity': 'الكمية',
        'Unit Cost': 'التكلفة',
        'Batches': 'الدفعات',
        'Info': 'المعلومات',
        'Batch': 'الدفعة',
        'Substitute': 'البديل',
        'Substitutes': 'البدائل',
        'Article Substitutes': 'بدائل المنتجات',
        '-Select-': '-إختر-',
        'designs': 'التصاميم',
        'contracts': 'العقود',
        'goods': 'البضائع',
        'Total Before Discount': 'الإجمالي قبل الخصم',
        'Tax': 'الضريبة',
        'Discount': 'الخصم',
        'Total After Discount': 'الإجمالي بعد الخصم',
        'Total': 'الإجمالي',
        'Net Total': 'الإجمالي الصافي',
        'Received': 'المستلم',
        'Change': 'المتبقي',
        'Payment Method': 'طريقة الدفع',
        'Due': 'المستحق',
        'Paid': 'المدفوع',
        'Print After Save': 'طباعة بعد الحفظ',
        'Print': 'طباعة',
        'Clear': 'مسح',
        'Grand Total': 'الإجمالي النهائي',
        'Account Statement': 'كشف حساب',
        'From Date': 'من تاريخ',
        'To Date': 'إلى تاريخ',
        'Account Number': 'رقم الحساب',
        'Start Balance': 'الرصيد الإفتتاحي',
        'End Balance': 'الرصيد الختامي',
        'Balance': 'الرصيد',
        'Voucher Type': 'نوع السند',
        'Group Account Code': 'كود حساب المجموعة',
        'Account Code': 'كود الحساب',
        'Account Name': 'إسم الحساب',
        'Opening Balance': 'الرصيد الإفتتاحي',
        'Debit Balance': 'الرصيد المدين',
        'Credit Balance': 'الرصيد الدائن',
        'Closing Balance': 'الرصيد الختامي',
        'Account Search': 'بحث الحساب',
        'Add Record': 'إضافة سجل',
        'Records Management': 'إدارة السجلات',
        'Select Option': '-إختر-',
        'Templates': 'القوالب',
        'Index Fields': 'حقول الفهرس',
        'Outbox': 'الصادر',
        'Type': 'النوع',
        'Reference': 'المرجع',
        'Party Name': 'إسم الجهة',
        'You cannot save an invoice with zero total amount': 'لا يمكن حفظ فاتورة بإجمالي صفر',
        'Created At': 'تاريخ الإنشاء',
        'Actions': 'الإجراءات',
        'Branches': 'الفروع',
        'Client Info': 'معلومات العميل',
        'Optional': 'إختياري',
        'System Logs': 'سجلات النظام',
        'Design Requests': 'طلبات التصميم',
        'Engineer Notes': 'ملاحظات المهندس',
        'Signature': 'التوقيع',
        'Design Request has been saved successfully': 'تم حفظ طلب التصميم بنجاح',
        'Engineer': 'المهندس',
        'Number': 'الرقم',
        'Price': 'السعر',
        'Contract Date': 'تاريخ العقد',
        'Total Amount': 'المبلغ الإجمالي',
        'Add Contract': 'إضافة عقد',
        'Role saved successfully': 'تم حفظ الدور بنجاح',
        'Done': 'تم',
        'ZATCA': 'الزكاة و الدخل',
        'External Sync': 'مزامنة خارجية',
        'Theme': 'المظهر',
        'Search in menu': 'البحث في القائمة',
        'Prefix': 'البادئة',
        'Change Language': 'تغيير اللغة',
        'Account': 'الحساب',
        'Amount': 'المبلغ',
        'Voucher No': 'رقم السند',
        'Reference No': 'رقم المرجع',
        'Reference Date': 'تاريخ المرجع',
        'Draft': 'مسودة',
        'Posted': 'مرحل',
        'Post': 'ترحيل',
        'Total Contracts': 'إجمالي العقود',
        'qty': 'حبة',
        'Service Sales Account': 'حساب مبيعات الخدمات',
        'Service Purchase Account': 'حساب مشتريات الخدمات',
        'Pending': 'معلق',
        'PENDING': 'معلق',
        'pending': 'معلق',
        'ID': 'الرقم',
        'Replacement Employee': 'الموظف البديل',
        'Duration': 'المدة',
        'Read': 'قراءة',
        'Details': 'التفاصيل',
        'all': 'الكل',
        'employees': 'الموظفين',
        'departments': 'الأقسام',
        'inward': 'وارد',
        'outward': 'صادر',
        'General': 'عام',
        'Features': 'المميزات',
        'Sms': 'رسائل نصية',
        'Printing': 'طباعة',
        'Survey': 'إستبيان',
        'Financial': 'مالي',
        'Enable POS': 'تفعيل نقطة البيع',
        'Scan Barcode Or Search': 'مسح الباركود أو البحث',
        'Cart': 'السلة',
        'Party': 'الجهة',
        'Shipping': 'الشحن',
        'Others': 'أخرى',
        'Please set your organization Tax number in settings': 'الرجاء تحديد رقم الضريبة لمؤسستك في الإعدادات',
        'TheProduct': 'المنتج',
        'TheService': 'الخدمة',
        'Please select record type': 'الرجاء إختيار نوع السجل',
        'Please enter record title': 'الرجاء إدخال عنوان السجل',
        'Error': 'خطأ',
        'Publish': 'نشر',
        'Download': 'تحميل',
        'Settings Updated successfully': 'تم تحديث الإعدادات بنجاح',
        'Success': 'نجاح',
        'From Branch': 'من الفرع',
        'To Branch': 'إلى الفرع',
        'Stock Transfer': 'نقل المخزون',
        'Use POS': 'يستخدم نقطة البيع',
        'Stock Adjustment': 'تسوية المخزون',
        'Stock Adjustment Reason': 'سبب تسوية المخزون',
        'Affect Stock': 'تأثير المخزون',
        'Affect Financials': 'تأثير مالي',
        'The Debit Account': 'الحساب المدين',
        'The Credit Account': 'الحساب الدائن',
        'From Account': 'من حساب',
        'To Account': 'إلى حساب',
        'Deposits': 'السدادات',
        'Invoice No': 'رقم الفاتورة',
        'Invoice Date': 'تاريخ الفاتورة',
        'Remains': 'المتبقي',
        'Deposit Amount': 'مبلغ السداد',
        'Your session will expire in': 'ستنتهي جلستك في',
        'please login again': 'الرجاء تسجيل الدخول مرة أخرى',
        'Session Expired': 'إنتهت الجلسة',
        'Seconds': 'ثواني',
        'Extend': 'تمديد',
        'Extra': 'إضافي',
        'Invoices Register': 'سجل الفواتير',
        'Cheque No': 'رقم الشيك',
        'Cheque Date': 'تاريخ الشيك',
        'Cheque Amount': 'مبلغ الشيك',
        'Cheque Account': 'حساب الشيك',
        'Cheque Bank': 'بنك الشيك',
        'Cheque Branch': 'فرع الشيك',
        'Cheque Details': 'تفاصيل الشيك',
        'Import Vouchers': 'إستيراد السندات',
        'Import Voucher': 'إستيراد سند',
        'Type voucher number and press enter to add': 'أدخل رقم السند و إضغط على enter لإضافته',
        'Day Book': 'دفتر اليومية',
        'Summarized': 'ملخص',
        'Detailed': 'تفصيلي',
        'Password': 'كلمة المرور',
        'Please enter your company code': 'الرجاء إدخال كود الشركة',
        'Please enter your username': 'الرجاء إدخال إسم المستخدم',
        'Please enter your password': 'الرجاء إدخال كلمة المرور',
        'Show Header': 'إظهار الترويسة',
        'Show Footer': 'إظهار التذييل',
        'Show Logo': 'إظهار الشعار',
        'Address': 'العنوان',
        'CR No': 'رقم السجل التجاري',
        'TIN': 'الرقم الضريبي',
        'Phone': 'الهاتف',
        'Taxable': 'ضريبية',
        'Pay Type': 'طريقة الدفع',
        'Notes': 'ملاحظات',
        'Net Amount': 'المبلغ الصافي',
        'Tax Amount': 'مبلغ الضريبة',
        'Vat': 'ضريبة القيمة المضافة',
        'Invoice Total': 'إجمالي الفاتورة',
        'Amount in Words': 'المبلغ كتابة',
        'Vat Default Rate': 'نسبة الضريبة الإفتراضية',
        'Vat Account': 'حساب الضريبة',
        'Default Rate': 'سعر الوحدة الإفتراضي',
        'Customer': 'العميل',
        'Supplier': 'المورد',
        'Sales Man': 'مندوب المبيعات',
        'Delete Group': 'حذف المجموعة',
        'Delete Account': 'حذف الحساب',
        'Add Account': 'إضافة حساب',
        'Add Group': 'إضافة مجموعة',
        'Export': 'تصدير',
        'Import': 'إستيراد',
        'Export Data': 'تصدير البيانات',
        'Thank You': 'شكرا لكم',
        'Return Policy': 'سياسة الإرجاع',
        'Terms & Conditions': 'الشروط و الأحكام',
        'Privacy Policy': 'سياسة الخصوصية',
        'About Us': 'من نحن',
        'Delivery Signature': 'توقيع الإستلام',
        'Powered By': 'مدعوم بواسطة',
        'Email Or User Name': 'البريد الإلكتروني أو إسم المستخدم',
        'Logo Update': 'تحديث الشعار',
        'Logo': 'الشعار',
        'active': 'نشط',
        'Points': 'النقاط',
        'Invoice': 'الفاتورة',
        'Category': 'الفئة',
        'Template': 'القالب',
        'Import Template': 'قالب الإستيراد',
        'Role': 'الدور',
        'Add New Branch': 'إضافة فرع جديد',
        'Edit Branch': 'تعديل الفرع',
        'Type Name': 'إدخل الإسم',
        'Name in Arabic': 'الإسم بالعربية',
        'Yes': 'نعم',
        'No': 'لا',
        'Header Margin': 'هامش الترويسة',
        'Header Logo Height': 'إرتفاع الشعار في الترويسة',
        'Header Logo Width': 'عرض الشعار في الترويسة',
        'Address Details': 'تفاصيل العنوان',
        'Full Address': 'العنوان بالكامل',
        'Unit Number': 'رقم الوحدة',
        'Building Number': 'رقم المبنى',
        'Street Name': 'إسم الشارع',
        'City': 'المدينة',
        'Country': 'الدولة',
        'Postal Code': 'الرمز البريدي',
        'State': 'المنطقة',
        'Region': 'المنطقة',
        'Country Code': 'كود الدولة',
        'Postal Zone': 'الرمز البريدي',
        'Phone Number': 'رقم الهاتف',
        'Street': 'الشارع',
        'User is already online': 'المستخدم متصل مسبقا' + ', ' + 'الرجاء تسجيل الخروج من الأجهزة المتصلة أولا',
        'User is already logged in': 'المستخدم مسجل الدخول مسبقا' + ', ' + 'الرجاء تسجيل الخروج من الاجهزة المتصلة أولا',
        'Plot Identification': 'رقم اللوحة',
        'INVOICE NO': 'رقم الفاتورة',
        'INVOICE DATE': 'تاريخ الفاتورة',
        'INVOICE TO': 'مفوتر لـ',
        'DATE': 'التاريخ',
        'Tax Number': 'الرقم الضريبي',
        'CR': 'السجل التجاري',
        'Seller': 'البائع',
        'AR': 'ع',
        'EN': 'En',
        'Select Language': 'إختر اللغة',
        'From': 'من',
        'To': 'إلى',
        'Accounts Receivable Statement': 'كشف حساب عميل',
        'Accounts Payable Statement': 'كشف حساب مورد',
        'Ageing Statement': 'كشف  أعمار الديون',
        '--Select--': '--إختر--',
        'Add New Voucher': 'إضافة سند جديد',
        'Add New Invoice': 'إضافة فاتورة جديدة',
        'Email address Or Username': 'البريد الإلكتروني أو إسم المستخدم',
        'Create your account. It\'s free and only takes a minute.': 'إنشاء حسابك. إنه مجاني ويستغرق دقيقة واحدة فقط',
        'Full Name': 'الإسم بالكامل',
        'Confirm Password': 'تأكيد كلمة المرور',
        'Already have an account?': 'هل لديك حساب مسبق؟',
        'Terms of Use': 'شروط الاستخدام',
        'I accept the': 'أوافق على',
        'Oops...': 'عذراً...',
        'Something went wrong. Please try again.': 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',
        'Registration successful!': 'تم التسجيل بنجاح!',
        'Sign in to your account': 'تسجيل الدخول إلى حسابك',
        'Sign in': 'تسجيل الدخول',
        'Remember me': 'تذكرني',
        'Welcome back!': 'مرحباً بعودتك!',
        'Don\'t have an account ?': 'ليس لديك حساب؟',
        'Forgot your password?': 'نسيت كلمة المرور؟',
        'Reset Password': 'إعادة تعيين كلمة المرور',
        'Back To Home': 'العودة إلى الرئيسية',
        'Please fill in all fields!': 'الرجاء ملء جميع الحقول!',
        'Follow Us': 'تابعنا',
        'Follow us on social media': 'تابعنا على وسائل التواصل الاجتماعي',
        'Offices Location': 'مواقع المكاتب',
        'Quick Links': 'روابط سريعة',
        'Contact Us': 'تواصل معنا',
        'Admin Panel': 'لوحة التحكم',
        'InProgress': 'قيد التنفيذ',
        'Completed': 'مكتمل',
        'Add / Edit Project': 'إضافة / تعديل مشروع',
        'Ingredients': 'المكونات',
        'Cost': 'التكلفة',
        'Add Project': 'إضافة مشروع',
        'Our Projects': 'مشاريعنا',
        'Configurations': 'الإعدادات',
        'Corp Name': 'إسم الشركة',
        'Corp Info.': 'معلومات الشركة',
        'Saving...': 'جاري الحفظ...',
        'Saved': 'تم الحفظ',
        'Mobile': 'رقم الجوال',
        'Fax': 'الفاكس',
        'Office Location': 'موقع المكتب',
        'Our Addresses': 'عناويننا',
        'Head Office': 'المكتب الرئيسي',
        'Clients': 'العملاء',
        'Suppliers': 'الموردين',
        'Dashboard': 'لوحة التحكم',
        'Selection of Our Recent Projects': 'مجموعة مختارة من مشاريعنا الحديثة',
        'Work Showcase': 'عرض الأعمال',
        'Meet Our Experts': 'تعرف على خبرائنا',
        'Our Team': 'فريقنا',
        'Basic Info.': 'المعلومات الأساسية',
        'Project Units': 'وحدات المشروع',
        'Project Media': 'وسائط المشروع',
        'Please save the project first': 'الرجاء حفظ المشروع أولاً',
        'Unit Description': 'وصف الوحدة',
        'Unit Space': 'مساحة الوحدة',
        'Unit Price': 'سعر الوحدة',
        'Unit Type': 'نوع الوحدة',
        'Unit Name': 'إسم الوحدة',
        'Public': 'عام',
        'Owner': 'المالك',
        'days': 'يوم',
        'hours': 'ساعة',
        'months': 'شهر',
        'years': 'سنة',
        'Are you sure?': 'هل أنت متأكد؟',
        'You won\'t be able to revert this!': 'لن تتمكن من التراجع عن هذا!',
        'Yes, delete it!': 'نعم، احذفه!',
        'No, cancel!': 'لا، إلغاء!',
        'Cancelled': 'تم الإلغاء',
        'Deleted': 'تم الحذف',
        'File size should be less than 1MB': 'حجم الملف يجب أن يكون أقل من 1 ميجابايت',
        'Media': 'الوسائط',
        'Media Type': 'نوع الوسائط',
        'Preview': 'معاينة',
        'Images Converter': 'تحويل الصور',
        'Format Images is Preffered': 'تنسيق الصور المفضل',
        'For More Info.': 'لمزيد من المعلومات',
        'Convert your images format': 'قم بتحويل تنسيق الصور الخاصة بك',
        'Add Unit': 'إضافة وحدة',
        'We designed your space': 'نحن نصمم مساحتك',
        'Interesting Facts About Construction industry': 'بعض إحصائياتنا',
        'have any question feel free to contact us': 'لديك أي أسئلة؟ لا تتردد في الاتصال بنا',
        'Request a Quote': 'طلب عرض',
        'complete name': 'إسمك بالكامل',
        'email address': 'عنوان بريدك الإلكتروني',
        'phone number': 'رقم هاتفك',
        'message': 'رسالتك',
        'send message': 'إرسال رسالة',
        'Submit Now': 'إرسال الآن',
        'finished projects': 'مشاريعنا المكتملة',
        'house interior design': 'تصميم داخلي ',
        'expert designer': 'مصمم متخصص',
        'Construction': 'التصميم',
        'Construction industry': 'صناعة',
        'Interior Design': 'تصميم داخلي',
        'Design': 'تصميم',
        'Interior': 'داخلية',
        'Designer': 'مصمم',
        'Modern Structures': 'تصاميم حديثة',
        'Ideas': 'أفكار',
        'Best Materials To': 'أفضل المواد ل',
        'Build a House': 'بناء منزل',
        'As a national leader in our industry': 'بما أننا من رائدي المجال',
        'We are revolutionizing what you expect from a contractor': 'نحن نحدث ثورة في عالم المقاولات',
        'Discover Projects': 'استكشف مشاريعنا',
        'The Construction Quality and': 'جودة الصناعة والخدمة',
        'Best Solutions': 'أفضل الحلول',
        'standards, which can include safety, cost, schedule, and performance': 'المعايير, بما في ذلك الأمان، التكلفة، الجدول الزمني و الأداء',
        'We Build Your': 'نحن نبني لك',
        'Dream House': 'منزل الأحلام',
        'Imagine a space designed just for you—a place where every detail': 'تخيل مساحتك كما تريدها أن تكون و تكون كل تفاصيلها',
        'reflects your unique': 'يظهر رؤيتك',
        'style and needs': 'و المتطلبات الخاصة بك',
        'Construction Services': 'خدمات المقاولات',
        'We Offer Comprehensive Construction Services': 'نوفر حلول شاملة لخدمات المقاولات',
        'Commercial': 'تجاري',
        'Contracting': 'عقود',
        'Residential': 'سكني',
        'We care about the communities we our communities too': 'نهتم برغبات الناس',
        'we\’re designers': 'نحن مصممون',
        'and projects mannagers, innovating of community, creativity': 'و مدراء مشاريع, نسعى بالإبتكار لفهم المجتمع',
        'Building your own home is about desire, fantasy. But it’s achievable anyone can do it': 'بناء المنزل الخاص حلم. ولكن يمكن لأي شخص أن يحقق ذلك',
        'Subscribe Newsletter': 'اشترك في النشرة الإخبارية',
        'Sending...': 'إرسال...',
        'Your message has been sent successfully!': 'تم إرسال رسالتك بنجاح!',
        'Estimation Calculator': 'حاسبة التكلفة',
        'Construction Estimation Calculator': 'حاسبة تكلفة البناء',
        'bones': 'عظم',
        'finishing': 'تشطيب',
        'key_delivery': 'تسليم المفتاح',
        'Real Estate Type': 'نوع العقار',
        'Select Type': '-يرجى الإختيار-',
        'Villas': 'فيلا',
        'Apartments': 'شقق',
        'Buildings': 'مباني',
        'project_type_finishing': 'تشطيب',
        'project_type_bones_and_finishing': ' عظم و تشطيب',
        'project_type_bones': 'عظم',
        'project_type_key_delivery': 'تسليم المفتاح',
        'Get Estimation': 'احسب التكلفة',
        'Tank': 'الخزان',
        'tank_hint': `بالتريلة 30 طن * 2 - مثال: 30طن = 15م×2 , الأقل :0, الأعلى :9999`,
        'Social Media': 'وسائل التواصل الاجتماعي',
        'Instagram': 'انستغرام',
        'Facebook': 'فيسبوك',
        'Twitter': 'تويتر',
        'LinkedIn': 'لينكد إن',
        'Youtube': 'يوتيوب',
        'YouTube': 'يوتيوب',
        'WhatsApp': 'واتساب',
        'Whatsapp': 'واتساب',
        'Telegram': 'تليجرام',
        'Snapchat': 'سناب شات',
        'TikTok': 'تيكتوك',
        'New Partner': 'شريك جديد',
        'Partners': 'شركاء النجاح',
        'Thumbnail': 'معاينة',
        'Urban planning': 'تخطيط عمراني',
        'Land development': 'تطوير أراضٍ',
        'Footer Text': 'نص التذييل',
        'Suggestion': 'اقتراح',
        'Project Cost': 'تكلفة المشروع',
        'Units': 'الوحدات',
        'Units Count': 'عدد الوحدات',
        'Space': 'المساحة',
        'Bayyarah': 'بيارة',
        'bayyarah_hint': 'الأقل :0, الأعلى :9999',
        'Soor': 'سور',
        'soor_hint': 'الأقل :0, الأعلى :9999',
        'Sitrah': 'سترة',
        'sitrah_hint': 'الأقل :0, الأعلى :9999',
        'Land Floor': 'الدور الأرضي',
        'land_floor_hint': 'الأقل :0, الأعلى :9999',
        'Recur Floor': 'الأدوار المتكررة',
        'recur_floor_hint': 'الأقل :0, الأعلى :9999',
        'Relative Floor': 'الملحق',
        'relative_floor_hint': 'الأقل :0, الأعلى :9999',
        'Stair Box': 'بيت الدرج',
        'stair_box_hint': 'الأقل :0, الأعلى :9999',
        'Building': 'عمارة',
        'Calculator.Qty': 'العدد',
        'Print Estimation': 'طباعة',
        'Please fill in the required fields!': 'الرجاء ملء الحقول المطلوبة!',
        'villa': 'فيلا',
        'apartment': 'شقة',
        'building': 'عمارة',
        'land': 'أرض',
        'Estimation': 'عرض سعر',
        'Total Space': 'المساحة الإجمالية',
        'Total Cost': 'التكلفة الإجمالية',
        'Please login to print the estimation!': 'الرجاء تسجيل الدخول لطباعة عرض السعر',
        'Do you want to print the estimation?': 'هل تريد طباعة عرض السعر؟',
        'Estimations': 'عروض الأسعار',
        'Approved': 'موافق عليه',
        'Completion Date': 'تاريخ الإنجاز',
        'Estimation Details': 'تفاصيل عرض السعر',
        'tank': 'الخزان',
        'bayyarah':'البيارة',
        'soor':'السور',
        'sitrah':'السترة',
        'land_floor':'الدور الأرضي',
        'recur_floor':'المتكرر',
        'relative_floor':'الملحق',
        'stair_box':'بيت الدرج',
        'Totals': 'الإجماليات',
        'Ratio': 'النسبة',
        'Confirmation': 'تأكيد',
        'Confirm': 'تأكيد',
        'Welcome': 'مرحباً',
        'Admin': 'الإدارة',
        'My Orders': 'طلباتي',
        'My Projects': 'مشاريعي',
        'in_progress': 'قيد التنفيذ',
        'completed': 'مكتمل',
        'cancelled': 'ملغي',
        'confirmed': 'مؤكد',
        'Our Messages': 'رسالتنا',
        'Our Vision': 'رؤيتنا',
        'Our Mission': 'هدفنا',
        'Our Values': 'قيمنا',
        'Create User': 'إنشاء مستخدم',
        'Add / Edit User': 'إضافة / تعديل مستخدم',
        'Add User': 'إضافة مستخدم',
        'Edit User': 'تعديل مستخدم',
        'Please select a role!': 'الرجاء إختيار دور!',
        'Show Password': 'إظهار كلمة المرور',
        'Update User': 'تحديث المستخدم',
        'Supervisor': 'مشرف',
        'Manager': 'مدير',
        'User': 'مستخدم',
        'Employee': 'موظف',
        'admin': 'مدير النظام',
        'supervisor': 'مشرف',
        'manager': 'مدير',
        'user': 'مستخدم',
        'employee': 'موظف',
        'Select Role': 'إختر الدور',
        'client': 'عميل',
        'create': 'إنشاء',
        'edit': 'تعديل',
        'delete': 'حذف',
        'view': 'عرض',
        'print': 'طباعة',
        'read': 'قراءة',
        'update': 'تحديث',
        'users': 'المستخدمين',
        'projects': 'المشاريع',
        'orders': 'الطلبات',
        'invoices': 'الفواتير',
        'estimation': 'عرض سعر',
        'settings': 'الإعدادات',
        'clients': 'العملاء',
        'suppliers': 'الموردين',
        'partners': 'الشركاء',
        'Permissions saved successfully!': 'تم حفظ الصلاحيات بنجاح',
        'Requests': 'الطلبات',
    },
};

export default localeResources;
